import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api";

export const reportKeys = {
	catalog: ["reports", "catalog"] as const,
	history: ["reports", "history"] as const,
};

export function useReportCatalog() {
	return useQuery({
		queryKey: reportKeys.catalog,
		queryFn: () => api.reports.catalog(),
	});
}

export function useReportHistory() {
	return useQuery({
		queryKey: reportKeys.history,
		queryFn: () => api.reports.history(),
	});
}

/**
 * Generate a report. AI variants take 5–15s server-side, so the mutation's
 * pending state drives the loader copy. The history list is refreshed on
 * success — a freshly generated report must appear there immediately.
 */
export function useGenerateReport() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ type, days }: { type: string; days?: number }) =>
			api.reports.generate(type, days),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: reportKeys.history }),
	});
}
